import useModal from "../../useModal";
import UseContext from "../../../../hooks/useContext";
import Modalheader from "../../components/header";
import ModalBody from "../../components/body";
import ModalFooter from "../../components/footer";
import Button from "../../../../components/button";
import SubmitButton from "../../../../components/button/SubmitButton";
import React, { useState } from "react";
import ApiDatabase from "../../../../server";

const ModalDeleteQualification = () => {
  const { toggle } = useModal();
  const { modalData } = UseContext();
  const [submitting, setSubmitting] = useState(false);

  const qualification = modalData?.qualification;
  const onSuccess = modalData?.onSuccess;

  const handleSubmit = () => {
    if (!qualification?._id) return;
    setSubmitting(true);
    ApiDatabase.deleteQualification(
      { id: qualification._id },
      () => {
        setSubmitting(false);
        if (onSuccess) onSuccess();
        toggle();
      },
      () => setSubmitting(false)
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Supprimer le poste
      </Modalheader>
      <ModalBody>
        <div className="ft-sm">
          Êtes-vous sûr de vouloir supprimer le poste <strong>{qualification?.name}</strong> de
          votre compte ?
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="SECONDARY" size="LG" onClick={toggle}>
          Annuler
        </Button>
        <SubmitButton loading={submitting} onClick={handleSubmit} />
      </ModalFooter>
    </>
  );
};

export default ModalDeleteQualification;
